import Highcharts from 'highcharts';
import Cookies from 'js-cookie';
import $ from 'jquery';
import EventService from '../common/event/EventService';
import PortalEvent from './events/PortalEvent';
import VcomProvider from '../VcomProvider';

export default function Layout() {
  let contentHeight = null;
  let contentLeft = null;
  let contentWidth = null;
  let contentHeightCompatibleWithRowHeight = null;
  let contentWidthCompatibleWithColumnWidth = null;
  let theme = null;

  function getTheme() {
    return theme;
  }

  function setHighchartBackgroundByTheme() {
    if (typeof Highcharts !== 'undefined') {
      if (theme === 'darkify') {
        Highcharts.setOptions({
          chart: {
            backgroundColor: '#272b35',
            plotBorderColor: '#606063',
          },
          xAxis: {
            gridLineColor: 'transparent',
            labels: {
              style: {
                color: '#e0e0e3',
              },
            },
            lineColor: '#bababa',
            tickColor: '#707073',
            minorTickColor: '#707073',
            title: {
              style: {
                color: '#a0a0a3',
              },
            },
          },
          yAxis: {
            gridLineColor: '#777777',
            gridLineWidth: 1,
            labels: {
              style: {
                color: '#e0e0e3',
              },
            },
            tickColor: '#707073',
            tickWidth: 1,
            title: {
              style: {
                color: '#a0a0a3',
              },
            },
          },
          legend: {
            itemStyle: {
              color: '#e0e0e3',
            },
            itemHoverStyle: {
              color: '#ffffff',
            },
            itemHiddenStyle: {
              color: '#606063',
            },
          },
          tooltip: {
            backgroundColor: '#393F4C',
            style: {
              color: '#CCCCCC',
            },
            borderRadius: 0,
            borderWidth: 0,
          },
          navigation: {
            buttonOptions: {
              symbolStroke: '#dddddd',
              theme: {
                fill: 'transparent',
              },
            },
          },
          plotOptions: {
            area: {
              borderColor: 'transparent',
            },
            series: {
              borderColor: 'transparent',
            },
          },
        });
      } else {
        Highcharts.setOptions({
          chart: {
            backgroundColor: 'rgba(255,255,255,1)',
            plotBorderColor: '#c0c0c0',
          },
          xAxis: {
            lineColor: '#bababa',
            gridLineColor: 'transparent',
            labels: {
              style: {
                color: '#666666',
              },
            },
            tickColor: '#a0a0a0',
            title: {
              style: {
                color: '#6d869f',
              },
            },
          },
          yAxis: {
            gridLineColor: '#E9E9E9',
            gridLineWidth: 1,
            labels: {
              style: {
                color: '#666666',
              },
            },
            tickColor: '#a0a0a0',
            title: {
              style: {
                color: '#6d869f',
              },
            },
          },
          legend: {
            itemStyle: {
              color: '#3e576f',
            },
            itemHoverStyle: {
              color: '#000000',
            },
            itemHiddenStyle: {
              color: '#c0c0c0',
            },
          },
          tooltip: {
            backgroundColor: '#F5F5F5',
            style: {
              color: '#3D3D3D',
            },
            borderRadius: 0,
            borderWidth: 0,
          },
          navigation: {
            buttonOptions: {
              symbolStroke: '#666666',
              theme: {
                fill: 'transparent',
              },
            },
          },
        });
      }
    }
  }

  function setTheme(newTheme) {
    theme = newTheme;
    Cookies.set('vcom-ui-theme', newTheme, {
      expires: 365,
      path: VcomProvider.baseUrl,
      sameSite: 'Lax',
    });
  }

  function recalculateDimensions() {
    contentHeight = $(window).height() - ($('#header').height() + $('#footer').outerHeight(true));
    const sideBarEl = $('#sidebar');
    contentLeft = sideBarEl.outerWidth() + sideBarEl.position().left;
    contentWidth = $(window).width() - contentLeft - parseInt($('.portal').css('margin-left'), 10);
  }

  function resize() {
    recalculateDimensions();
    contentHeightCompatibleWithRowHeight = contentHeight
      - (contentHeight % VcomProvider.Portal.getRows());
    contentWidthCompatibleWithColumnWidth = contentWidth
      - (contentWidth % VcomProvider.Portal.getColumns());
    $('#content').css('left', contentLeft).width($(window).width() - contentLeft).height(contentHeight);
    $('#sidebar').outerHeight(contentHeight);
    EventService.dispatch(PortalEvent.DIMENSIONS_CHANGED);
  }

  return {
    init() {
      const currentTheme = $('#current-theme').attr('data-theme-id');
      theme = Cookies.get('vcom-ui-theme') || 'mcflat';

      if (theme !== currentTheme) {
        setTheme(currentTheme);
      }

      setHighchartBackgroundByTheme();

      resize();

      $(window).on('resize', () => {
        resize();
      });

      const portalEl = $('.portal');
      portalEl.height(contentHeightCompatibleWithRowHeight);
      portalEl.width(contentWidthCompatibleWithColumnWidth);

      $(document).on('mouseenter mouseleave', '.editable', (event) => {
        $(event.currentTarget).toggleClass('ui-state-highlight mc-state-inline-highlight');
      });

      $('#theme-control-options').find('a').on('click', (event) => {
        const newTheme = $(event.currentTarget).attr('data-theme-id');

        if (newTheme !== currentTheme) {
          setTheme(newTheme);
          $('body').mask();
          window.location.reload(true);
        }

        return false;
      });
    },
    getContentWidth() {
      return contentWidth;
    },
    getContentHeight() {
      return contentHeight;
    },
    getContentHeightCompatibleWithRowHeight() {
      return contentHeightCompatibleWithRowHeight;
    },
    getContentWidthCompatibleWithColumnWidth() {
      return contentWidthCompatibleWithColumnWidth;
    },
    getTheme,
    resize,
  };
}
